// extracted by mini-css-extract-plugin
export default {"AuthButtons":"AuthButtons_AuthButtons__F-WGP"};